export const ConsultationOrderCn = {
    xunjiadang:'购买记录',
    fanhui:'返回',
    quanbu:'全部订单',
    daizhifu:'待支付',
    daishenghe:'待审核',
    yizhifu:'已支付',
    yiwangcheng:'已完成',
    yipingjia:'已评价',
    yizuiping:'已追评',
    zuanjiaxinxi:'专家信息',
    jiage:'价格',
    zixunjindu:'订单状态',
    caozuo:'操作',
    qingshuru:'请输入订单号关键字/专家名称',
    sousuo:'搜索',
    dingdh:'订单号',
    xiadsj:'下单时间',
    dingdxq:'订单详情',
    dingdzf:'订单支付',
    jingruzx:'进入咨询',
    zxpj:'咨询评价',
    zczx:'再次咨询',
    zxls:'咨询历史',
    zjzxpj:'专家咨询评价',
    zjpj:'追加评价',
    zxshic:'咨询时长',
    xiaoshi:'小时',
    zjsp:'专家水平',
    huifzl:'回复质量',
    huifsd:'回复速度',
    pingjiasd:'评价晒单',
    fenxiangtiyan:'分享体验心得，给万千想买的人一个参考',
    busaoyu:'评价不少于10个字',
    tijiaopj:'提交评价',
    daipj:'待评价',
    lijipingjia:'立即评价',
    liszx:'历史咨询',
    ddpj:'订单评价',
    jianczl:'检测质量',
    pinglfs:'评论分数',
    shangctp:'上传图片',
    yiquxiao:'已取消'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/ConsultationOrder/ConsultationOrderCn.js